import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index/index'
import aboutAs from '../views/about-as/about-as'
import settledBrand from '../views/settled-brand/settled-brand'
import brandMerchant from '../views/brand-merchants/brand-merchants'
import contactUs from '../views/contact-us/contact-us'
import squareDynamic from '../views/square-dynamic/square-dynamic'
import businessLicense from '../views/business-license/business-license'
import settledDetails from '../views/settled-details/settled-details'
import squareDetails from '../views/square-details/square-details'

Vue.use(VueRouter)

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/about-as',
      name: 'about',
      component: aboutAs
    },
    {
      path: '/settled-brand',
      name: 'settled',
      component: settledBrand
    },
    {
      path: '/brand-merchants',
      name: 'brand',
      component: brandMerchant
    },
    {
      path: '/square-dynamic',
      name: 'square',
      component: squareDynamic
    },
    {
      path: '/contact-us',
      name: 'contact',
      component: contactUs
    },
    {
      path: '/business-license',
      name: 'license',
      component: businessLicense
    },
    {
      path: '/settled-details',
      name: 'settled-details',
      component: settledDetails
    },
    {
      path: '/square-details',
      name: 'square-details',
      component: squareDetails
    }
  ]
})

// const router = new VueRouter({
//   routes
// })

// export default routes
